// Smartsetup Application Configuration
//======================================================================================//
// Application Basic Info
export const appName = "Project setup";

//======================================================================================//
// Application API URLs UAT
// export const appBaseUrl = "https://uatpreventtb237.imonitorplus.com/";
// export const appApiUrl = "https://uatpreventtb237.imonitorplus.com/service/api/";

// Application API URLs LIVE
// export const appBaseUrl = "https://tptdemo.imonitorplus.com/";
// export const appApiUrl = "https://tptdemo.imonitorplus.com/service/api/";

// Application API URLs Dev

export const appBaseName = "cdicv2";
export const appAdminModuleName = "cdicdashboardv2";
export const appBaseUrl = "https://cdic.imonitorplus.com/";
export const appApiUrl = "https://cdic.imonitorplus.com/service/api/";

// Application API URLs Local
// export const appBaseUrl = "http://localhost:8080/";
// export const appApiUrl = "http://localhost:8080/dhis/api/";
//======================================================================================//

